import React from 'react';
import AppModal from '../../../common/AppModal';
import CustomerProfileForm from '../../../../forms/CustomerProfileForm';
import useLocalization from '../../../../hooks/useLocalization';

const AddEditCustomerProfileModal = ({
  show,
  onHide,
  editMode,
  showProgress,
  initialValues,
  onSubmit,
  onDeleteClick,
  onToggleApproval,
  onPublishForReview,
  relatedDeals,
  fromCustomerPortal
}) => {
  const { translate } = useLocalization();

  const modalTitle = (
    <div className="d-flex align-items-center gap-2">
      <span>{!editMode ? translate('add_customer_profile') : translate('edit_customer_profile')}</span>
      {!fromCustomerPortal && initialValues?.showToCustomer && (
        <span className="badge bg-primary text-white py-0.5">
          {translate('created_by_customer')}
        </span>
      )}
    </div>
  );

  return (
    <AppModal
      size={'lg'}
      title={modalTitle}
      show={show}
      onHide={onHide}
      modalBodyClassName="px-0 py-1"
    >
      <CustomerProfileForm
        editMode={editMode}
        showProgress={showProgress}
        values={initialValues}
        onSubmit={onSubmit}
        onDeleteClick={onDeleteClick}
        onToggleApproval={onToggleApproval}
        onPublishForReview={onPublishForReview}
        relatedDeals={relatedDeals}
        fromCustomerPortal={fromCustomerPortal}
      />
    </AppModal>
  );
};

export default AddEditCustomerProfileModal;
